// Token is held in-memory only. It is never persisted to localStorage or
// sessionStorage, so it cannot be read from a JS-accessible store at rest and
// does not survive a full page reload or a new tab (auth is re-acquired then).
let memoryToken: string | null = null;

const getToken = (): string | null => memoryToken;

const setToken = (token: string): void => {
  memoryToken = token;
};

const clearToken = (): void => {
  memoryToken = null;
};

export { getToken, setToken, clearToken };
